import React from "react";
import { Paper } from "@mantine/core";
import JobForm from "../components/JobForm";
import { useNavigate, useParams } from "react-router-dom";
import { useGetJobQuery } from "../graphql";
import StyledPageTitle from "../components/StyledPageTitle";

const JobsUpdatePage: React.FC = () => {
  const navigate = useNavigate();
  const params = useParams<{ id: string }>();
  const getJob = useGetJobQuery({
    variables: { id: `${params.id}` },
  });

  const job = getJob.data?.getJob;

  return (
    <>
      <StyledPageTitle>Update Job</StyledPageTitle>
      <Paper>
        {job && (
          <JobForm job={job} onSubmit={(id) => navigate(`/app/jobs/${id}`)} />
        )}
      </Paper>
    </>
  );
};

export default JobsUpdatePage;
